import angular from 'angular';

export default function() {

  return {
    restrict: 'A',
    replace: true,
    template: ($element) => {
      const tooltipValue = $element.attr('akam-tooltip');
      const classes = angular.isDefined($element.attr('arrow')) ?
        'arrow akam-tooltip' : 'akam-tooltip';
      const placement = angular.isDefined($element.attr('tooltip-placement')) ?
         $element.attr('tooltip-placement') : 'bottom';

      $element.removeAttr('akam-tooltip')
        .attr('uib-tooltip', tooltipValue)
        .attr('tooltip-placement', placement)
        .attr('tooltip-class', classes);

      return $element[0].outerHTML;
    }
  };
}
